import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../shared/common.service';
import { ToastService } from '../shared/toast.service';
import { LoaderService } from '../shared/loader.service';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-verify-session',
  templateUrl: './verify-session.component.html',
  styleUrls: ['./verify-session.component.scss']
})
export class VerifySessionComponent implements OnInit {
  videoUrl!: SafeResourceUrl;

  sessionId: string | null = null;
  manualSessionId: string = ''; // For manual input
  packageId: string | null = null;
  email: string | null = null;
  packageName: string | null = null;
  verificationStatus: 'loading' | 'success' | 'failed' | 'error' | 'input' = 'input';
  errorMessage: string | null = null;
  submitted = false;
  isVerifying = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private toastService: ToastService,
    private loaderService: LoaderService,
    private sanitizer: DomSanitizer
  ) {}

 // Add these properties at the top of the class
showNoPaymentAlert = false;
redirectCountdown = 7;
timerProgress = 100;
private countdownInterval: any;

ngOnInit(): void {
  const youtubeLink = 'https://www.youtube.com/embed/rL4zzMLGBCs';
  this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(youtubeLink);

  this.route.queryParams.subscribe(params => {
    this.sessionId = params['session_id'] || null;
    this.packageId = params['packageId'] || null;
    this.email = params['email'] || '';
    this.packageName = params['package'] || 'Unknown Package';

    if (!this.sessionId) {
      // ❌ No session ID — show non-declinable modal then redirect
      this.showNoPaymentAlert = true;
      this.startRedirectCountdown();
      return;
    }

    // ✅ Has session ID — existing flow untouched
    this.verificationStatus = 'loading';
    this.loaderService.show();
    this.verifyCheckoutSession(this.sessionId);
  });
}

startRedirectCountdown(): void {
  const totalSeconds = 5;
  this.redirectCountdown = totalSeconds;
  this.timerProgress = 100;

  this.countdownInterval = setInterval(() => {
    this.redirectCountdown--;
    this.timerProgress = (this.redirectCountdown / totalSeconds) * 100;

    if (this.redirectCountdown <= 0) {
      clearInterval(this.countdownInterval);
      this.redirectNow();
    }
  }, 1000);
}

redirectNow(): void {
  clearInterval(this.countdownInterval);
  this.showNoPaymentAlert = false;

  if (this.packageId) {
    window.location.href = `https://academy.nexgencoaches.com/billing-form?packageId=${this.packageId}`;
  } else {
    window.location.href = 'https://nexgencoaches.com/programs/';
  }
}

ngOnDestroy(): void {
  clearInterval(this.countdownInterval);
}
  onVerifySession(): void {
    this.submitted = true;
    if (!this.manualSessionId) {
      this.toastService.showError('Please enter a session ID');
      return;
    }

    this.verificationStatus = 'loading';
    this.isVerifying = true;
    this.loaderService.show();
    this.verifyCheckoutSession(this.manualSessionId);
  }

  verifyCheckoutSession(sessionId: string): void {
    this.commonService.verifyCheckoutSession(sessionId).pipe(
      tap((response: any) => {
        if (response.status === 1) {
          this.verificationStatus = 'success';
          this.toastService.showSuccess('Payment verified successfully! Redirecting to login...');
          console.log('✅ Payment verified:', response.data);
          
          // Add a small delay before redirect to show the success message
          setTimeout(() => {
            this.redirectToLogin();
          }, 2000); // 2 second delay
        } else {
          this.verificationStatus = 'failed';
          this.errorMessage = response.message || 'Payment verification failed';
          this.manualSessionId = ''; // Clear input on failure
          this.toastService.showError(this.errorMessage || "Payment verification failed");
        }
      }),
      catchError((error) => {
        console.error('❌ Error verifying checkout session:', error);
        this.verificationStatus = 'error';
        this.errorMessage = error.message || 'An error occurred during verification';
        this.manualSessionId = ''; // Clear input on error
        this.toastService.showError('An error occurred during verification. Please try again.');
        return throwError(() => error);
      })
    ).subscribe(() => {
      this.isVerifying = false;
      this.loaderService.hide();
    });
  }

  redirectToLogin(): void {
    // Option 1: Using Router (recommended for Angular apps)
    this.router.navigate(['/login'], { 
      queryParams: { 
        verified: 'true',
        email: this.email || '',
        package: this.packageName || ''
      }
    });
    
    // Option 2: Using window.location.href (if you need full page reload)
    // window.location.href = 'https://nexgencoaches.com/login?verified=true';
    
    // Option 3: If login is at a specific path
    // window.location.href = '/login?verified=true';
  }

  retryPayment() {
    window.location.href = 'https://nexgencoaches.com/programs';
    // or relative path
    // window.location.href = '/payment';
  }

  goToHome() {
    window.location.href = 'https://nexgencoaches.com/';
    // or relative path
    // window.location.href = '/';
  }
}